import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.machinedetails.components';

export default defineMessages({
    po_comment_title: { id: `${scope}.po_comment_title`, defaultMessage: 'Copy description to machine comment' },
    po_comment_question: { id: `${scope}.po_comment_question`, defaultMessage: 'Do you want to add the description before the existing machine comment or replace the comment?' },
    po_comment_cancel: { id: `${scope}.po_comment_cancel`, defaultMessage: 'Cancel' },
    po_comment_replace: { id: `${scope}.po_comment_replace`, defaultMessage: 'Replace' },
    po_comment_prepend: { id: `${scope}.po_comment_prepend`, defaultMessage: 'Add' },
    po_comment_saved: { id: `${scope}.po_comment_saved`, defaultMessage: 'Machine comment updated.' },
    po_comment_error: { id: `${scope}.po_comment_error`, defaultMessage: 'Could not update the machine comment.' },
    hideStopCharts: {
        id: `${scope}.button.hideStopCharts`,
        defaultMessage: 'Hide charts',
    },
    showStopCharts: {
        id: `${scope}.button.showStopCharts`,
        defaultMessage: 'Show charts',
    },
    stopReasonCode: {
        id: `${scope}.machinestopeditdialog.label.stopreasoncode`,
        defaultMessage: 'Stop Reason Code',
    },
    comment: {
        id: `${scope}.machinestopeditdialog.label.comment`,
        defaultMessage: 'Comment',
    },
    machineName: {
        id: `${scope}.machinestopeditdialog.label.machinename`,
        defaultMessage: 'Machine Name',
    },
    duration: {
        id: `${scope}.machinestopeditdialog.label.duration`,
        defaultMessage: 'Duration',
    },
    minutes: {
        id: `${scope}.machinestopeditdialog.label.minutes`,
        defaultMessage: 'minutes',
    },
    item: {
        id: `${scope}.machinestopeditdialog.label.item`,
        defaultMessage: 'Item',
    },
    updated: {
        id: `${scope}.machinestopeditdialog.label.updated`,
        defaultMessage: 'Updated',
    },
    updatedBy: {
        id: `${scope}.machinestopeditdialog.label.updatedBy`,
        defaultMessage: 'Updated by',
    },
    machineStatus: {
        id: `${scope}.label.machineStatus`,
        defaultMessage: 'Machine status',
    },
    machine: {
        id: `${scope}.label.machine`,
        defaultMessage: 'Machine',
    },
    itemInProduction: {
        id: `${scope}.label.itemInProduction`,
        defaultMessage: 'Item in production',
    },
    productionOrder: {
        id: `${scope}.label.productionOrder`,
        defaultMessage: 'Production order',
    },
    percentageDone: {
        id: `${scope}.label.percentageDone`,
        defaultMessage: 'Percentage done',
    },
    t: {
        id: `${scope}.label.t`,
        defaultMessage: 'A',
    },
    a: {
        id: `${scope}.label.a`,
        defaultMessage: 'P',
    },
    k: {
        id: `${scope}.label.k`,
        defaultMessage: 'Q',
    },
    tak: {
        id: `${scope}.label.tak`,
        defaultMessage: 'OEE',
    },
    takt: {
        id: `${scope}.label.takt`,
        defaultMessage: 'Pace',
    },
    plannedQty: {
        id: `${scope}.label.plannedQty`,
        defaultMessage: 'Planned Qty',
    },
    reportedQty: {
        id: `${scope}.label.reportedQty`,
        defaultMessage: 'Reported Qty',
    },
    remainingQty: {
        id: `${scope}.label.remainingQty`,
        defaultMessage: 'Remaining Qty',
    },
    remainingTime: {
        id: `${scope}.label.remainingTime`,
        defaultMessage: 'Remaining time',
    },
    remainingTimeDays: {
        id: `${scope}.label.remainingTimeDays`,
        defaultMessage: 'Remaining time',
    },
    scrappedQty: {
        id: `${scope}.label.scrappedQty`,
        defaultMessage: 'Scrapped Qty',
    },
    nrOfCycles: {
        id: `${scope}.label.nrOfCycles`,
        defaultMessage: 'Nr of cycles',
    },
    days: {
        id: `${scope}.label.days`,
        defaultMessage: 'days',
    },
    downtime: {
        id: `${scope}.label.downtime`,
        defaultMessage: 'Downtime',
    },
    downtimeNoOee: {
        id: `${scope}.label.downtimeNoOee`,
        defaultMessage: 'Downtime not affecting OEE',
    },
    uptime: {
        id: `${scope}.label.uptime`,
        defaultMessage: 'Uptime',
    },
    uptimeExplenation: {
        id: `${scope}.label.uptimeExplenation`,
        defaultMessage: "Uptime\nThe time when the machine is actually running and producing parts according to plan.\n\nExamples:\n• Machine is running and producing parts\n• Automatic production mode\n• Stable production without stops",
    },
    downtimeExplenation: {
        id: `${scope}.label.downtimeExplenation`,
        defaultMessage: "Downtime that affects OEE\nStops or losses that count as production loss and reduce the OEE value.\n\nExamples:\n• Unplanned stops\n• Machine breakdowns\n• Tool changes taking longer than planned\n• Material shortage during planned production time\n• Setup and adjustment problems\n\nIn short: things that reduce production when the machine should be running.",
    },
    downtimeNoOeeExplenation: {
        id: `${scope}.label.downtimeNoOeeExplenation`,
        defaultMessage: "Downtime that does NOT affect OEE\nPlanned or expected stops that are excluded from OEE and do not count as losses.\n\nExamples:\n• Planned maintenance\n• Breaks and pauses\n• Scheduled meetings\n• Planned changeovers\n• Machine stopped outside planned production time\n\nIn short: stops that are “okay” because they are already part of the plan.",
    },
    info: {
        id: `${scope}.label.info`,
        defaultMessage: 'Info',
    },
    description: {
        id: `${scope}.label.description`,
        defaultMessage: 'Description',
    },
    opcServerUrl: {
        id: `${scope}.label.opcServerUrl`,
        defaultMessage: 'OPC Server Url',
    },
    opcServerStatus: {
        id: `${scope}.label.opcServerStatus`,
        defaultMessage: 'OPC Server Status',
    },
    area: {
        id: `${scope}.label.area`,
        defaultMessage: 'Area',
    },
    machineType: {
        id: `${scope}.label.machineType`,
        defaultMessage: 'Machine type',
    },
    oeePercentWarning: {
        id: `${scope}.label.oeePercentWarning`,
        defaultMessage: 'OEE Percent Warning',
    },
    oeePercentBad: {
        id: `${scope}.label.oeePercentBad`,
        defaultMessage: 'OEE Percent Bad',
    },
    avalibleStopReasonCodes: {
        id: `${scope}.label.avalibleStopReasonCodes`,
        defaultMessage: 'Available stop reason codes',
    },

    autocodeMicroStopsHeadline: {
        id: `${scope}.label.autocodeMicroStopsHeadline`,
        defaultMessage: 'Autocode micro stops',
    },
    autocodeMicroStops: {
        id: `${scope}.label.autocodeMicroStops`,
        defaultMessage: 'Autocode micro stops',
    },
    microStopMaxSeconds: {
        id: `${scope}.label.microStopMaxSeconds`,
        defaultMessage: 'Micro stop max seconds',
    },
    microStopsDefaultStopReason: {
        id: `${scope}.label.microStopsDefaultStopReason`,
        defaultMessage: 'Micro stops default stop reason code',
    },
    idealCycleTimeActive: {
        id: `${scope}.label.idealCycleTimeActive`,
        defaultMessage: 'Ideal CT',
    },
    lastCycleTime: {
        id: `${scope}.label.lastCycleTime`,
        defaultMessage: 'Last CT',
    },
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    splitStop: {
        id: `${scope}.label.splitStop`,
        defaultMessage: 'Split stop',
    },
    editStop: {
        id: `${scope}.label.editStop`,
        defaultMessage: 'Edit stop',
    },
    editSettings: {
        id: `${scope}.label.editSettings`,
        defaultMessage: 'Edit settings',
    },
    editComment: {
        id: `${scope}.label.editComment`,
        defaultMessage: 'Add/Edit comment',
    },
    stopCount: {
        id: `${scope}.label.stopCount`,
        defaultMessage: 'Stop count',
    },
    currentShiftFilter: {
        id: `${scope}.label.filters.currentShift`,
        defaultMessage: 'Current shift',
    },
    prevShiftFilter: {
        id: `${scope}.label.filters.prevShift`,
        defaultMessage: 'Prev.shift',
    },
    dayFilter: {
        id: `${scope}.label.filters.24h`,
        defaultMessage: '24h',
    },
    threeDayFilter: {
        id: `${scope}.label.filters.72h`,
        defaultMessage: '72h',
    },
    manualFilter: {
        id: `${scope}.label.filters.manual`,
        defaultMessage: 'Manual',
    },
    weekFilter: {
        id: `${scope}.label.filters.week`,
        defaultMessage: 'Week',
    },
    linksAndFunctions: {
        id: `${scope}.label.linksAndFunctions`,
        defaultMessage: 'Manual',
    },
    machineComments: {
        id: `${scope}.label.machineComments`,
        defaultMessage: 'Manual',
    },
    settingsButtonTooltip: {
        id: `${scope}.label.settingsButtonTooltip`,
        defaultMessage: 'Manual',
    },
    commentButtonTooltip: {
        id: `${scope}.label.commentButtonTooltip`,
        defaultMessage: 'Manual',
    },
    grafanaButtonTooltip: {
        id: `${scope}.label.grafanaButtonTooltip`,
        defaultMessage: 'Manual',
    },
    plcLogButtonTooltip: {
        id: `${scope}.label.plcLogButtonTooltip`,
        defaultMessage: 'Manual',
    },
    oeeStartDateTime: {
        id: `${scope}.label.oeeStartDateTime`,
        defaultMessage: 'OEE Start DateTime',
    },
    fromDate: {
        id: `${scope}.label.fromDate`,
        defaultMessage: 'From date',
    },
    fromTime: {
        id: `${scope}.label.fromTime`,
        defaultMessage: 'To date',
    },
    toDate: {
        id: `${scope}.label.toDate`,
        defaultMessage: 'From time',
    },
    toTime: {
        id: `${scope}.label.toTime`,
        defaultMessage: 'To time',
    },
    activityTriggered: {
        id: `${scope}.label.activityTriggered`,
        defaultMessage: 'An activity was created when the stop was updated.',
    },
    useStopPageOnGrafanaLink: {
        id: `${scope}.label.useStopPageOnGrafanaLink`,
        defaultMessage: 'Use stop page on Grafana link',
    },
    showPaceAsCycleTime: {
        id: `${scope}.label.showPaceAsCycleTime`,
        defaultMessage: 'Show pace as cycle time',
    },
    meassureAvailability: {
        id: `${scope}.label.meassureAvailability`,
        defaultMessage: 'Measure availability',
    },
    availabilityPercentWarning: {
        id: `${scope}.label.availabilityPercentWarning`,
        defaultMessage: 'Availability percent warning',
    },
    availabilityPercentBad: {
        id: `${scope}.label.availabilityPercentBad`,
        defaultMessage: 'Availability percent bad',
    },
    meassurePerformance: {
        id: `${scope}.label.meassurePerformance`,
        defaultMessage: 'Measure performance',
    },
    notifyOnNewActivity: {
        id: `${scope}.label.notifyOnNewActivity`,
        defaultMessage: 'Notify on new activity',
    },
    notifyEmail: {
        id: `${scope}.label.notifyEmail`,
        defaultMessage: 'Notify email',
    },
    performancePercentWarning: {
        id: `${scope}.label.performancePercentWarning`,
        defaultMessage: 'Performance percent warning',
    },
    performancePercentBad: {
        id: `${scope}.label.performancePercentBad`,
        defaultMessage: 'Performance percent bad',
    },
    meassureQuality: {
        id: `${scope}.label.meassureQuality`,
        defaultMessage: 'Measure quality',
    },
    qualityPercentWarning: {
        id: `${scope}.label.qualityPercentWarning`,
        defaultMessage: 'Quality percent warning',
    },
    qualityPercentBad: {
        id: `${scope}.label.qualityPercentBad`,
        defaultMessage: 'Quality percent bad',
    },
    targetValue: {
        id: `${scope}.label.targetValue`,
        defaultMessage: 'Target value',
    },
    newActivity: {
        id: `${scope}.label.newActivity`,
        defaultMessage: 'New activity',
    },
    newActivityText: {
        id: `${scope}.label.newActivityText`,
        defaultMessage: 'There is a new activity for this machine. Check the activity tab for more information.',
    },
    Ok: {
        id: `${scope}.label.ok`,
        defaultMessage: 'Ok',
    },
    showActivities: {
        id: `${scope}.label.showActivities`,
        defaultMessage: 'Show activities',
    },
    activity: {
        id: `${scope}.label.activity`,
        defaultMessage: 'Activity',
    },
    completeBefore: {
        id: `${scope}.label.completeBefore`,
        defaultMessage: 'Complete before',
    },
    in: {
        id: `${scope}.label.in`,
        defaultMessage: 'in',
    },
    hours: {
        id: `${scope}.label.hours`,
        defaultMessage: 'hours',
    },
    autocode: {
        id: `${scope}.label.autocode`,
        defaultMessage: 'Autocode stops',
    },
    machineActivitiesTimespanHelptext: {
        id: `${scope}.label.machineActivitiesTimespanHelptext`,
        defaultMessage: 'Help text',
    },
    pace: {
        id: `${scope}.label.pace`,
        defaultMessage: 'Pace',
    },
    idealPace: {
        id: `${scope}.label.idealPace`,
        defaultMessage: 'Ideal pace',
    },
    currentPace: {
        id: `${scope}.label.currentPace`,
        defaultMessage: 'Current pace',
    },
    avgPaceForPo: {
        id: `${scope}.label.avgPaceForPo`,
        defaultMessage: 'Avgerage pace for PO',
    },
    timespanSelectorLabel: {
        id: `${scope}.label.timespanSelectorLabel`,
        defaultMessage: 'Show the pace for the last:',
    },
    avgCycleTimeForPo: {
        id: `${scope}.label.avgCycleTimeForPo`,
        defaultMessage: 'Avgerage cycle time for PO',
    },
    useCycleTimeForPace: {
        id: `${scope}.label.useCycleTimeForPace`,
        defaultMessage: 'Show pace as with unit',
    },
    currentCycleTime: {
        id: `${scope}.label.currentCycleTime`,
        defaultMessage: 'Current cycle time',
    },
    cycleTime: {
        id: `${scope}.label.cycleTime`,
        defaultMessage: 'Cycle time',
    },
    time: {
        id: `${scope}.label.time`,
        defaultMessage: 'Time',
    },
    autocodeInstructions: {
        id: `${scope}.label.autocodeInstructions`,
        defaultMessage: 'Autocode instructions',
    },
    cancelAutocode: {
        id: `${scope}.label.cancelAutocode`,
        defaultMessage: 'Cancel autocode',
    },
    autocodeInProgress: {
        id: `${scope}.label.autocodeInProgress`,
        defaultMessage: 'Autocode in progress',
    },
    autocodeEndsIn: {
        id: `${scope}.label.autocodeEndsIn`,
        defaultMessage: 'Autocode ends in: ',
    },
    endAutocodeNow: {
        id: `${scope}.label.endAutocodeNow`,
        defaultMessage: 'End now',
    },
    unitsPerHour: {
        id: `${scope}.label.unitsPerHour`,
        defaultMessage: 'Units per hour',
    },
    changeMachineTabOnInactivity: {
        id: `${scope}.label.changeMachineTabOnInactivity`,
        defaultMessage: 'Change machine tab on inactivity',
    },
    inactivityTime: {
        id: `${scope}.label.inactivityTime`,
        defaultMessage: 'Inactivity time',
    },
    changeToTabIfRunning: {
        id: `${scope}.label.changeToTabIfRunning`,
        defaultMessage: 'Change to tab if running',
    },
    changeToTabIfStopped: {
        id: `${scope}.label.changeToTabIfStopped`,
        defaultMessage: 'Change to tab if not running',
    },
    alarm: {
        id: `${scope}.label.alarm`,
        defaultMessage: 'Alarm.',
    },
    high: {
        id: `${scope}.label.high`,
        defaultMessage: 'High.',
    },
    low: {
        id: `${scope}.label.low`,
        defaultMessage: 'Low.',
    },
    pausedalarm: {
        id: `${scope}.label.pausedalarm`,
        defaultMessage: 'Paused alarm.',
    },
    moduleNotEnabled: {
        id: `${scope}.moduleNotEnabled`,
        defaultMessage: 'Module not enabled',
    },
    speedUnitType: {
        id: `${scope}.label.speedUnitType`,
        defaultMessage: 'Speed unit type',
    },
    speedUnitTypeNotSet: {
        id: `${scope}.label.speedUnitTypeNotSet`,
        defaultMessage: 'Not set',
    },
    speedUnitTypeCycleTimeSeconds: {
        id: `${scope}.label.speedUnitTypeCycleTimeSeconds`,
        defaultMessage: 'Cycle time (s)',
    },
    speedUnitTypePaceItemsPerHour: {
        id: `${scope}.label.speedUnitTypePaceItemsPerHour`,
        defaultMessage: 'Pace (items/hour)',
    },
    speedUnitTypeSpeedMetersPerMinute: {
        id: `${scope}.label.speedUnitTypeSpeedMetersPerMinute`,
        defaultMessage: 'Speed (m/min)',
    },
    speedUnitTypeSpeedKgPerMinute: {
        id: `${scope}.label.speedUnitTypeSpeedKgPerMinute`,
        defaultMessage: 'Speed (kg/min)',
    },
    speedUnitTypePaceItemsPerMinute: {
        id: `${scope}.label.speedUnitTypePaceItemsPerMinute`,
        defaultMessage: 'Pace (items/minute)',
    },
    tabDashboard: {
        id: `${scope}.label.tabDashboard`,
        defaultMessage: 'Dashboard',
    },
    tabActivities: {
        id: `${scope}.label.tabActivities`,
        defaultMessage: 'Activities',
    },
    tabTakt: {
        id: `${scope}.label.tabTakt`,
        defaultMessage: 'Takt',
    },
    tabSensorData: {
        id: `${scope}.label.tabSensorData`,
        defaultMessage: 'Sensor data',
    },
    tabAlarms: {
        id: `${scope}.label.tabAlarms`,
        defaultMessage: 'Alarms',
    },
    tabMachineStops: {
        id: `${scope}.label.tabMachineStops`,
        defaultMessage: 'Machine stops',
    },
    tabProductionOrders: {
        id: `${scope}.label.tabProductionOrders`,
        defaultMessage: 'Production orders',
    },
    downtimeInMinutes: {
        id: `${scope}.label.downtimeInMinutes`,
        defaultMessage: 'Downtime in minutes',
    },
    noActiveProductionOrder: {
        id: `${scope}.label.noActiveProductionOrder`,
        defaultMessage: 'No active production order',
    },
    noSensorData: {
        id: `${scope}.label.noSensorData`,
        defaultMessage: 'No sensor data',
    },
    splitStopsOnShiftChange: {
        id: `${scope}.label.splitStopsOnShiftChange`,
        defaultMessage: 'Split stop on shift change',
    },
    quickSelectMachine: {
        id: `${scope}.label.quickSelectMachine`,
        defaultMessage: 'Quick select machine',
    },
    changingToActiveShift: {
        id: `${scope}.label.changingToActiveShift`,
        defaultMessage: 'Changing to "active shift" due to shift change.',
    },
    resetTimespanOnShiftChange: {
        id: `${scope}.label.resetTimespanOnShiftChange`,
        defaultMessage: 'Reset timespan on shift change',
    },
    overrideUndefinedStopReasonCodeId: {
        id: `${scope}.label.overrideUndefinedStopReasonCodeId`,
        defaultMessage: 'Override undefined stop reason code',
    },
    loadErrorTitle: {
        id: `${scope}.label.loadErrorTitle`,
        defaultMessage: "We can't load machine data at the moment. We are trying to reconnect.",
    },
    loadErrorBody: {
        id: `${scope}.label.loadErrorBody`,
        defaultMessage: 'If the problem persists, try reloading the page or logging out and back in.',
    },
    retry: {
        id: `${scope}.label.retry`,
        defaultMessage: 'Retry',
    },
    backToList: {
        id: `${scope}.label.backToMachines`,
        defaultMessage: 'Back to machines',
    },
    lastAttemptTime: {
        id: `${scope}.label.lastAttemptTime`,
        defaultMessage: 'Last attempt time',
    },
    initialErrorTime: {
        id: `${scope}.label.initialErrorTime`,
        defaultMessage: 'Initial error time',
    },
    otherStopReasonCodes: {
        id: `${scope}.label.otherStopReasonCodes`,
        defaultMessage: 'Other stop reason codes',
    },
    quickPicks: {
        id: `${scope}.label.quickPicks`,
        defaultMessage: 'Quick picks - Most used stop reason codes on the machine last 24h',
    },
    searchStopReasonCodes: {
        id: `${scope}.label.searchStopReasonCodes`,
        defaultMessage: 'Search stop reason codes...',
    },
    stopDetectionThreshold: {
        id: `${scope}.label.stopDetectionThreshold`,
        defaultMessage: 'The number of seconds since the last activity before the machine is detected as a stop.',
    },
    uncodedStopsAndOpenActivities: {
        id: `${scope}.label.uncodedStopsAndOpenActivities`,
        defaultMessage: 'Uncoded stops and open activities'
    },
    machineInSetup: {
        id: `${scope}.label.machineInSetup`,
        defaultMessage: 'Machine in setup',
    },
    machineInSetupEndsIn: {
        id: `${scope}.label.machineInSetupEndsIn`,
        defaultMessage: 'Machine in setup ends in: ',
    },
    machineInSetupLate: {
        id: `${scope}.label.machineInSetupLate`,
        defaultMessage: 'Machine in setup is late by: ',
    },
    machineInSetupOverlayTitle: {
        id: `${scope}.label.machineInSetupOverlayTitle`,
        defaultMessage: "Machine in setup",
    },
    machineInSetupOverlayDescription: {
        id: `${scope}.label.machineInSetupOverlayDescription`,
        defaultMessage: "The machine is currently in setup. Other information on the page is dimmed until the setup is expected to be finished. You can temporarily close this box to work with other information in the OEE system, but the setup is both started and finished in the ERP system. If this box is closed before the setup is finished, it will be displayed again when the page is reloaded or if you click on the setup info banner on the machine page.",
    },
    close: {
        id: `${scope}.label.close`,
        defaultMessage: "Close",
    },

    startLabel: {
        id: `${scope}.label.start`,
        defaultMessage: 'Start',
    },
    reportLabel: {
        id: `${scope}.label.report`,
        defaultMessage: 'Report',
    },
    stopLabel: {
        id: `${scope}.label.stop`,
        defaultMessage: 'Stop',
    },
    dialogheadding: {
        id: `${scope}.label.dialogheadding`,
        defaultMessage: 'Active production order details for machine ',
    },
    thisWeek: {
        id: `${scope}.label.thisWeek`,
        defaultMessage: "This week",
    },
    lastWeek: {
        id: `${scope}.label.lastWeek`,
        defaultMessage: "Last week",
    },
    stopProductionOrderTitle: {
        id: `${scope}.label.stopProductionOrderTitle`,
        defaultMessage: 'Stop active production order',
    },
    stopProductionOrderMessage: {
        id: `${scope}.label.stopProductionOrderMessage`,
        defaultMessage: 'Do you want to stop the active production order',
    },
    startProductionOrderTitle: {
        id: `${scope}.label.startProductionOrderTitle`,
        defaultMessage: 'Start active production order',
    },
    startProductionOrderMessage: {
        id: `${scope}.label.startProductionOrderMessage`,
        defaultMessage: 'Do you want to start the active production order',
    },
    setCavityOnStartTitle: {
        id: `${scope}.label.setCavityOnStartTitle`,
        defaultMessage: 'Set cavities',
    },
    setCavityOnStartMessage: {
        id: `${scope}.label.setCavityOnStartMessage`,
        defaultMessage: 'Set the number of items produced per cycle before starting the production order.',
    },
    setCavityOnStartLabel: {
        id: `${scope}.label.setCavityOnStartLabel`,
        defaultMessage: 'Cavities',
    },
    setCavityOnStartInvalid: {
        id: `${scope}.label.setCavityOnStartInvalid`,
        defaultMessage: 'Enter a whole number greater than zero.',
    },
    pauseProductionOrderTitle: {
        id: `${scope}.label.pauseProductionOrderTitle`,
        defaultMessage: 'Pause active production order',
    },
    pauseProductionOrderMessage: {
        id: `${scope}.label.pauseProductionOrderMessage`,
        defaultMessage: 'Do you want to pause the active production order',
    },
    yes: {
        id: `${scope}.label.yes`,
        defaultMessage: 'Yes',
    },
    no: {
        id: `${scope}.label.no`,
        defaultMessage: 'No',
    },
    btnStart: {
        id: `${scope}.label.btnStart`,
        defaultMessage: 'Start',
    },
    btnCancel: {
        id: `${scope}.label.btnCancel`,
        defaultMessage: 'Cancel',
    },

    startActiveProductionOrderTitle: {
        id: `${scope}.label.startActiveProductionOrderTitle`,
        defaultMessage: 'Start active production order',
    },
    pauseActiveProductionOrderTitle: {
        id: `${scope}.label.pauseActiveProductionOrderTitle`,
        defaultMessage: 'Pause active production order',
    },
    stopActiveProductionOrderTitle: {
        id: `${scope}.label.stopActiveProductionOrderTitle`,
        defaultMessage: 'Stop active production order',
    },
    reportActiveProductionOrderTitle: {
        id: `${scope}.label.reportActiveProductionOrderTitle`,
        defaultMessage: 'Report produced quantity for active production order',
    },
    reportScrapForActiveProductionOrderTitle: {
        id: `${scope}.label.reportScrapForActiveProductionOrderTitle`,
        defaultMessage: 'Report scrap for active production order',
    },
    orderDeletedMessage: {
        id: `${scope}.label.orderDeletedMessage`,
        defaultMessage: 'Active production order stopped successfully.',
    },
    orderUpdatedMessage: {
        id: `${scope}.label.orderUpdatedMessage`,
        defaultMessage: 'Active production order updated successfully.',
    },
    orderCreatedMessage: {
        id: `${scope}.label.orderCreatedMessage`,
        defaultMessage: 'Active production order started successfully.',
    },
    machineSection: {
        id: `${scope}.label.machineSection`,
        defaultMessage: 'Machine Section',
    },
    po_table_productionordernumber: {
        id: `${scope}.label.po_table_productionordernumber`,
        defaultMessage: 'PO No',
    }  ,
    po_table_reportnumber: {
        id: `${scope}.label.po_table_reportnumber`,
        defaultMessage: 'Report No',
    }  ,
    po_table_operation: {
        id: `${scope}.label.po_table_operation`,
        defaultMessage: 'Operation',
    },
    po_table_description: {
        id: `${scope}.label.po_table_description`,
        defaultMessage: 'Description',
    },
    po_table_item: {
        id: `${scope}.label.po_table_item`,
        defaultMessage: 'Item',
    },
    po_table_plannedstarttime: {
        id: `${scope}.label.po_table_plannedstarttime`,
        defaultMessage: 'Planned Start Time',
    },
    po_table_plannedquantity: {
        id: `${scope}.label.po_table_plannedquantity`,
        defaultMessage: 'Planned Qty',
    },
    po_table_producedquantity: {
        id: `${scope}.label.po_table_producedquantity`,
        defaultMessage: 'Produced Qty',
    },
    po_table_reportedquantity: {
        id: `${scope}.label.po_table_reportedquantity`,
        defaultMessage: 'Reported Qty',
    },
    po_table_idealcycletime: {
        id: `${scope}.label.po_table_idealcycletime`,
        defaultMessage: 'Ideal Cycle Time',
    },
    po_table_idealpace: {
        id: `${scope}.label.po_table_idealpace`,
        defaultMessage: 'Ideal Pace',
    },
    po_table_tool: {
        id: `${scope}.label.po_table_tool`,
        defaultMessage: 'Tool',
    },
    po_table_status: {
        id: `${scope}.label.po_table_status`,
        defaultMessage: 'Status',
    },
    po_table_cavity: {
        id: `${scope}.label.po_table_cavity`,
        defaultMessage: 'Cavity',
    },
    po_table_actions: {
        id: `${scope}.label.po_table_actions`,
        defaultMessage: 'Actions',
    },
    po_reportqty_header: {
        id: `${scope}.label.po_reportqty_header`,
        defaultMessage: 'Report production for machine:',
    },
    po_reportscrap_header: {
        id: `${scope}.label.po_reportscrap_header`,
        defaultMessage: 'Report Scrap for machine:',
    },
    po_scrap_madatorycomment: {
        id: `${scope}.label.po_scrap_madatorycomment`,
        defaultMessage: '* - A comment is mandatory for scrap code',
    },
    po_message_updated: {
        id: `${scope}.label.po_message_updated`,
        defaultMessage: 'Production order updated successfully.',
    },
    po_message_updated_error: {
        id: `${scope}.label.po_message_updated`,
        defaultMessage: 'Could not update production order.',
    },
    po_message_started: {
        id: `${scope}.label.po_message_started`,
        defaultMessage: 'Production order started successfully.',
    },
    po_message_created_error: {
        id: `${scope}.label.po_message_created_error`,
        defaultMessage: 'Could not start production order',
    },
    po_message_stopped: {
        id: `${scope}.label.po_message_stopped`,
        defaultMessage: 'Production order stopped successfully.',
    },
    po_message_stopped_error: {
        id: `${scope}.label.po_message_stopped_error`,
        defaultMessage: 'Could not stop production order',
    },
    po_status_planned: {
        id: `${scope}.label.po_status_planned`,
        defaultMessage: 'Planned',
    },
    po_status_inprogress: {
        id: `${scope}.label.po_status_inprogress`,
        defaultMessage: 'In Progress',
    },
    po_status_completed: {
        id: `${scope}.label.po_status_completed`,
        defaultMessage: 'Completed',
    },
    po_status_paused: {
        id: `${scope}.label.po_status_paused`,
        defaultMessage: 'Paused',
    },
    po_status_unknown: {
        id: `${scope}.label.po_status_unknown`,
        defaultMessage: 'Unknown',
    },
    po_report_searchuser: {
        id: `${scope}.label.po_report_searchuser`,
        defaultMessage: 'Search user...',
    },
    po_report_searchreasoncode: {
        id: `${scope}.label.po_report_searchreasoncode`,
        defaultMessage: 'Search reason code...',
    },
    po_report_addqty: {
        id: `${scope}.label.po_report_addqty`,
        defaultMessage: 'Report Quantity',
    },
    po_report_sign: {
        id: `${scope}.label.po_report_sign`,
        defaultMessage: 'Sign as',
    },
    po_report_btnreport: {
        id: `${scope}.label.po_report_btnreport`,
        defaultMessage: 'Report',
    },
    po_report_plannedqty: {
        id: `${scope}.label.po_report_plannedqty`,
        defaultMessage: 'Planned Quantity',
    },
    po_report_producedqty: {
        id: `${scope}.label.po_report_producedqty`,
        defaultMessage: 'Produced Quantity',
    },
    po_report_reportedqty: {
        id: `${scope}.label.po_report_reportedqty`,
        defaultMessage: 'Reported Quantity',
    },
    po_report_totalreportedqty: {
        id: `${scope}.label.po_report_totalreportedqty`,
        defaultMessage: 'Total Reported Quantity',
    },
    po_report_notReported: {
        id: `${scope}.label.po_report_notReported`,
        defaultMessage: 'Not Reported Qty',
    },
    po_report_remainingqty: {
        id: `${scope}.label.po_report_remainingqty`,
        defaultMessage: 'Remaining Quantity',
    },
    po_report_table_productionorderno: {
        id: `${scope}.label.po_report_table_productionorderno`,
        defaultMessage: 'Production Order No',
    },
    po_report_table_operationnumber: {
        id: `${scope}.label.po_report_table_operationnumber`,
        defaultMessage: 'Operation Number',
    },
    po_report_table_qty: {
        id: `${scope}.label.po_report_table_qty`,
        defaultMessage: 'Quantity',
    },
    po_report_table_reportedqty: {
        id: `${scope}.label.po_report_table_reportedqty`,
        defaultMessage: 'Reported Quantity',
    },
    po_report_table_user: {
        id: `${scope}.label.po_report_table_user`,
        defaultMessage: 'User',
    },
    po_report_table_updated: {
        id: `${scope}.label.po_report_table_updated`,
        defaultMessage: 'Updated',
    },
    po_report_tooltip_waiting_for_integration: {
        id: `${scope}.tooltip.po_report_waiting_for_integration`,
        defaultMessage: 'Waiting for integration to run',
    },
    po_report_tooltip_missing_integration_error: {
        id: `${scope}.tooltip.po_report_missing_integration_error`,
        defaultMessage: 'Qty not sent within the stated time frame and error message is missing. Is the integration running?',
    },
    po_report_tooltip_integration_error: {
        id: `${scope}.tooltip.po_report_integration_error`,
        defaultMessage: 'Error: {error}',
    },
    po_report_tooltip_sent_to_erp: {
        id: `${scope}.tooltip.po_report_sent_to_erp`,
        defaultMessage: 'Sent to ERP successfully',
    },
    po_report_table_comment: {
        id: `${scope}.label.po_report_table_comment`,
        defaultMessage: 'Comment',
    },
    po_report_table_scrapreasoncode: {
        id: `${scope}.label.po_report_table_scrapreasoncode`,
        defaultMessage: 'Scrap Reason Code',
    },
    po_message_invalidqty: {
        id: `${scope}.label.po_message_invalidqty`,
        defaultMessage: 'Invalid quantity',
    },
    po_report_addbatch: {
        id: `${scope}.label.po_report_addbatch`,
        defaultMessage: 'Add batch',
    },
    po_report_currentuser: {
        id: `${scope}.label.po_report_currentuser`,
        defaultMessage: 'Current User',
    },
    po_report_message_scrapped: {
        id: `${scope}.label.po_report_message_scrapped`,
        defaultMessage: 'Material scrapped',
    },
    po_report_message_scrapped_error: {
        id: `${scope}.label.po_report_message_scrapped_error`,
        defaultMessage: 'Error scrapping material: ',
    },
    po_report_message_invalidqty: {
        id: `${scope}.label.po_report_message_invalidqty`,
        defaultMessage: 'Invalid quantity',
    },
    po_report_message_forcedcomment: {
        id: `${scope}.label.po_report_message_forcedcomment`,
        defaultMessage: 'Comment is mandatory for this scrap reason',
    },
    po_report_message_invalidscrapreason: {
        id: `${scope}.label.po_report_message_invalidscrapreason`,
        defaultMessage: 'Invalid scrap reason',
    },
    po_report_comment: {
        id: `${scope}.label.po_report_comment`,
        defaultMessage: 'Comment',
    },
    btn_report: {
        id: `${scope}.label.btn_report`,
        defaultMessage: 'Report',
    },
    btn_report_description: {
        id: `${scope}.label.btn_report_description`,
        defaultMessage: 'Report for the machine',
    }
});
